export function requireNonNegativeNumber(problems, value, field, level = "error") {
  if (value === "" || value < 0) {
    problems.push({
      field,
      level,
      message: value === "" ? "Required Field" : "Value cannot be negative",
    });
  }
}

export function optionalNonNegativeNumber(problems, value, field, level = "error") {
  if (value === "") return;
  if (value < 0) {
    problems.push({
      field,
      level,
      message: "Value cannot be negative",
    });
  }
}

export function requireNotFalsy(problems, value, field, level = "error") {
  if (!value) {
    problems.push({
      field,
      level,
      message: "Required Field",
    });
  }
}
